import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { AuthenticationService } from '../services/authentication.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-ministry-postcards',
  templateUrl: './ministry-postcards.component.html',
  styleUrls: ['./ministry-postcards.component.css']
})
export class MinistryPostcardsComponent implements OnInit {
  activeTab: string = 'create';
  skip: number = 0;
  limit: number = 10;
announcemnts: any = [];
  recentAnnouncements: any[] = [];
pageNo: any;
pageSize: any;
totalItems;
objArr=[];
loading = false
  alertForm: FormGroup;
  isSubmittingAlert = false;
  showCreateAlert = false;
  postcardsPage = 1;
  postcardsTotal = 0;

  constructor(
    private ngxService: NgxUiLoaderService,
    public authenticationService: AuthenticationService,
    private fb: FormBuilder
  ) { }

  ngOnInit(): void {
    this.alertForm = this.fb.group({
      type: ['generalMessage', Validators.required],
      name: ['', [Validators.required, Validators.maxLength(120)]],
      description: ['', [Validators.required, Validators.maxLength(1000)]],
    });
    this.getAnnouncements(1);
    this.getRecentAnnouncements();
  }

  getScrollTo(tab: string) {
    this.activeTab = tab;
    if (tab === 'manage') {
      this.getRecentAnnouncements();
      this.showCreateAlert = false;
    }
  }

  toggleCreateAlert() {
    this.showCreateAlert = !this.showCreateAlert;
    if (this.showCreateAlert) {
      this.alertForm?.markAsUntouched();
    }
  }

  closeCreateAlert() {
    this.showCreateAlert = false;
  }

  alertTypeLabel(type: string): string {
    switch (type) {
      case 'generalMessage':
        return 'General';
      case 'emergencyUpdate':
        return 'Emergency';
      case 'importantUpdate':
        return 'Important';
      default:
        return type || 'Alert';
    }
  }

  alertTypeBadgeClass(type: string): string {
    switch (type) {
      case 'emergencyUpdate':
        return 'mm-badge mm-badge--danger';
      case 'importantUpdate':
        return 'mm-badge mm-badge--warning';
      case 'generalMessage':
      default:
        return 'mm-badge mm-badge--info';
    }
  }

  // getAllAnnouncements() {
  //   this.ngxService.start();
  //   this.authenticationService
  //     .getPostCards(0, 10, true)
  //     .subscribe((res: any) => {
  //       this.announcemnts = res.items;
  //       // this.announcemnts = [];
  //       this.ngxService.stop();
  //     }, error => {
  //       if (error) {
  //         Swal.fire(
  //           "error",
  //           error.error.message
  //         );
  //         this.ngxService.stop();
  //       }
  //     });
  // }


  
  // GET /api/merchant/affiliateCommunityAnnouncements
  getAnnouncements(page: number) {
    this.postcardsPage = Math.max(1, page);
    this.pageNo = this.postcardsPage;
    this.skip = (Math.max(1, page) - 1) * this.limit;
    this.objArr = [];
    this.ngxService.start();
    this.authenticationService
      .getAllAnnouncment(
        `/merchant/affiliateCommunityAnnouncements?skip=${this.skip}&limit=${this.limit}`
      )
      .subscribe(
        (res: any) => {
          this.announcemnts = res?.items || [];
          this.postcardsTotal = res?.total || this.announcemnts.length;
          this.totalItems = this.postcardsTotal;
          this.loading = true;
          this.announcemnts.forEach((e) => {
            this.objArr.push({
              id: e?._id || '',
              name: e?.name || '',
              description: e?.description || '',
              createdBy: e?.createdBy?.name || '',
            });
          });
          this.ngxService.stop();
        },
        (error) => {
          this.ngxService.stop();
          this.authenticationService.successMessage(
            error?.error?.message || 'Failed to load announcements',
            'error'
          );
        }
      );
  }

  get postcardsTotalPages(): number {
    if (!this.postcardsTotal || !this.limit) return 1;
    return Math.max(1, Math.ceil(this.postcardsTotal / this.limit));
  }

  postcardsPrevPage() {
    if (this.postcardsPage <= 1) return;
    this.getAnnouncements(this.postcardsPage - 1);
  }

  postcardsNextPage() {
    if (this.postcardsPage >= this.postcardsTotalPages) return;
    this.getAnnouncements(this.postcardsPage + 1);
  }

  // GET /api/merchant/getAllAnnouncement?skip=0&limit=100
  getRecentAnnouncements() {
    this.authenticationService
      .getAllAnnouncment(`/merchant/getAllAnnouncement?skip=0&limit=100`)
      .subscribe(
        (res: any) => {
          this.recentAnnouncements = res?.items || [];
        },
        (error) => {
          this.authenticationService.successMessage(
            error?.error?.message || 'Failed to load recent announcements',
            'error'
          );
        }
      );
  }

  // POST /api/merchant/alerts
  createAlert() {
    if (!this.alertForm || this.alertForm.invalid) {
      this.alertForm?.markAllAsTouched();
      return;
    }
    this.isSubmittingAlert = true;
    const payload = this.alertForm.value;
    this.authenticationService.postData('/merchant/alerts', payload).subscribe(
      (res: any) => {
        this.isSubmittingAlert = false;
        this.authenticationService
          .successMessage(res?.message || 'alert_created', 'success')
          .then(() => {
            // Refresh both tabs
            this.getAnnouncements(1);
            this.getRecentAnnouncements();
            this.closeCreateAlert();
          });
        this.alertForm.patchValue({
          type: 'generalMessage',
          name: '',
          description: '',
        });
        this.alertForm.markAsPristine();
      },
      (error) => {
        this.isSubmittingAlert = false;
        this.authenticationService.successMessage(
          error?.error?.message || 'Failed to create alert',
          'error'
        );
      }
    );
  }
}